<template>
	<div>
		<el-dialog :title="room_num ? `${room_num}房间的${DialogTitle}` : DialogTitle" :visible.sync="visible" center
			:close-on-click-modal="false" @close="onClose" :close-on-press-escape="false"
			:width="name == 'administrator' ? '60%' : '45%'" :append-to-body="true">
			<component :is="currentComponent" ref="child" :item="item" @changedia="onClose" :name="name"></component>
		</el-dialog>
	</div>
</template>

<script>
	import managementAdd from './components/Activities/management/managementAdd.vue'
	import managementEdit from './components/Activities/management/managementEdit.vue'
	import kindsAdd from './components/Activities/kinds/kindsAdd.vue'
	import kindsEdit from './components/Activities/kinds/kindsEdit.vue'
	import couponAdd from './components/Activities/coupon/couponAdd.vue'
	import couponEdit from './components/Activities/coupon/couponEdit.vue'
	import userAdd from './components/User/user/userAdd.vue'
	import userEdit from './components/User/user/userEdit.vue'
	import repairEdit from './components/User/repairEdit.vue'
	import contractAdd from './components/Contract/contract/contractAdd.vue'
	import contractEdit from './components/Contract/contract/contractEdit.vue'
	import contractEdit2 from './components/Contract/contract/contractEdit2.vue'
	import renewAdd from './components/Contract/renewAdd.vue'
	import renewEdit from './components/Contract/renewEdit.vue'
	import surrenderAdd from './components/Contract/surrenderAdd.vue'
	import surrenderEdit from './components/Contract/surrenderEdit.vue'
	import ordersAdd from './components/Bills/ordersAdd.vue'
	import ordersEdit from './components/Bills/ordersEdit.vue'
	import roomAdd from './components/Listings/room/roomAdd.vue'
	import roomEdit from './components/Listings/room/roomEdit.vue'
	import parametersAdd from './components/System/parameters/parametersAdd.vue'
	import parametersEdit from './components/System/parameters/parametersEdit.vue'
	import termsAdd from './components/System/terms/termsAdd.vue'
	import termsEdit from './components/System/terms/termsEdit.vue'
	import carouselAdd from './components/System/carousel/carouselAdd.vue'
	import carouselEdit from './components/System/carousel/carouselEdit.vue'
	import deviceAdd from './components/Device/deviceAdd.vue'
	import accessuserAdd from './components/Device/accessuserAdd.vue'
	import accessuserEdit from './components/Device/accessuserEdit.vue'
	import MetermanagementAdd from './components/Device/MetermanagementAdd.vue'
	import MetermanagementEdit from './components/Device/MetermanagementEdit.vue'
	import MetermanagementViews from './components/Device/MetermanagementViews.vue'
	import LockAdd from './components/Lock/LockAdd.vue'
	import LockEdit from './components/Lock/LockEdit.vue'
	import lockroomEdit from './components/Lock/lockroomEdit.vue'
	import Intelligent_water_meterEdit from './components/Intelligent_devices/Intelligent_water_meterEdit.vue'
	import ViewHistory from './components/Intelligent_devices/ViewHistory.vue'
	import recharge from './components/Intelligent_devices/recharge.vue'
	import administratorAdd from './components/System/administrator/administratorAdd.vue'
	import administratorEdit from './components/System/administrator/administratorEdit.vue'
	import ChangePassword from './components/System/administrator/ChangePassword.vue'
	import getimage from './components/System/administrator/getimage.vue'
	import bllisexport from './components/Bills/bllisexport.vue'
	import changetenant from './components/Contract/contract/changetenant.vue'
	export default {
		props: [
			'centerDialogVisible',
			'DialogTitle',
			'item',
			"options",
			'DisposeName',
			'name',
		],
		data() {
			return {
				currentComponent: '',
				show: this.centerDialogVisible,
				room_num: ''
			};
		},
		watch: {
			DialogTitle(newVal) {
				console.log('this.item::::', this.item);
				// this.room_num = this.item.room_num
				this.currentComponent = this.getComponentName(newVal);
				this.room_num = /添加|生成|创建/.test(newVal) ? '' : this.item.room_num;

			},
			item: function(newVal, oldVal) {
				console.log('newVal', newVal);
				var value = JSON.parse(JSON.stringify(this.item));
				this.room_num = value.room_num
			}
		},
		methods: {
			onClose(value) {
				this.$emit('changedia', value);
			},
			getComponentName(title) {
				switch (title) {
					case '添加活动':
						return 'managementAdd';
					case '活动编辑':
						return 'managementEdit';
					case '添加优惠券种类':
						return 'kindsAdd';
					case '优惠券种类编辑':
						return 'kindsEdit';
					case '添加优惠券':
						return 'couponAdd';
					case '优惠券编辑':
						return 'couponEdit';
					case '添加用户':
						return 'userAdd';
					case '用户编辑':
						return 'userEdit';
					case '报修编辑':
						return 'repairEdit';
					case '添加合同':
						return 'contractAdd';
					case '合同换房':
						return 'contractEdit';
					case '合同换人':
						return "changetenant";
					case '合同编辑':
						return "contractEdit2";
					case '创建续租':
						return 'renewAdd';
					case '续租审核':
						return 'renewEdit';
					case '创建退租':
						return 'surrenderAdd';
					case '退租审核':
						return 'surrenderEdit';
					case '生成订单':
						return 'ordersAdd';
					case '订单编辑':
						return 'ordersEdit';
					case '添加房间':
						return 'roomAdd';
					case '房间编辑':
						return 'roomEdit';
					case '添加参数':
						return 'parametersAdd';
					case '参数编辑':
						return 'parametersEdit';
					case '添加条款':
						return 'termsAdd';
					case '条款编辑':
						return 'termsEdit';
					case '添加轮播图':
						return 'carouselAdd';
					case '编辑轮播图':
						return 'carouselEdit';
					case '添加设备':
						return 'deviceAdd';
					case '添加人员':
						return "accessuserAdd";
					case '编辑人员':
						return "accessuserEdit";
					case '添加电表':
						return "MetermanagementAdd";
					case '编辑电表':
						return "MetermanagementEdit";
					case '查看电表':
						return "MetermanagementViews";
					case '添加水表':
						return "MetermanagementAdd";
					case '编辑水表':
						return "MetermanagementEdit";
					case '查看水表':
						return "MetermanagementViews";
					case '添加门锁设备':
						return "LockAdd";
					case '编辑门锁':
						return "LockEdit";
					case '编辑智能水表':
						return "Intelligent_water_meterEdit";
					case '编辑智能电表':
						return "Intelligent_water_meterEdit";
					case '智能水表历史':
						return "ViewHistory";
					case '智能电表历史':
						return "ViewHistory";
					case '充值':
						return "recharge";
					case '添加管理员':
						return "administratorAdd";
					case '编辑管理员':
						return "administratorEdit";
					case '修改密码':
						return "ChangePassword";
					case '绑定房间':
						return "lockroomEdit";
					case '导出账单':
						return "bllisexport";
					case '绑定公众号':
						return "getimage";


						// ... 其他 cases ...
					default:
						return ''; // 如果没有匹配的组件，则返回空字符串
				}
			}
		},
		components: {
			managementAdd,
			managementEdit,
			kindsAdd,
			kindsEdit,
			couponAdd,
			couponEdit,
			userAdd,
			userEdit,
			repairEdit,
			contractAdd,
			contractEdit,
			renewAdd,
			renewEdit,
			surrenderAdd,
			surrenderEdit,
			ordersAdd,
			ordersEdit,
			roomAdd,
			roomEdit,
			parametersAdd,
			parametersEdit,
			termsAdd,
			termsEdit,
			carouselAdd,
			carouselEdit,
			deviceAdd,
			accessuserAdd,
			accessuserEdit,
			MetermanagementAdd,
			MetermanagementEdit,
			MetermanagementViews,
			LockAdd,
			LockEdit,
			Intelligent_water_meterEdit,
			ViewHistory,
			recharge,
			administratorAdd,
			administratorEdit,
			ChangePassword,
			lockroomEdit,
			bllisexport,
			getimage,
			changetenant,
			contractEdit2
		},
		computed: {
			visible: {
				get() {
					return this.centerDialogVisible
				},
				set(value) {
					this.show = value;
				},
			},
		}
	};
</script>

<style scoped>
	>>>.el-dialog {
		display: flex;
		flex-direction: column;
		margin: 0 !important;
		position: absolute;
		top: 50%;
		left: 50%;
		/* width: 60% !important; */
		transform: translate(-50%, -50%);
		/*height:600px;*/
		max-height: calc(100% - 200px);
		max-width: calc(100% - 30px);

	}

	>>>.el-dialog .el-dialog__body {
		flex: 1;
		overflow: auto;
	}

	>>>.el-dialog__body::-webkit-scrollbar {
		width: 0.5rem;

	}

	>>>.el-dialog__body::-webkit-scrollbar-thumb {
		border-radius: 10px;
		background: rgba(0, 0, 0, 0.2);
	}

	>>>.el-dialog__body::-webkit-scrollbar-track {
		border-radius: 0;
		background: rgba(0, 0, 0, 0.1);
	}

	>>>.v-modal {
		z-index: 99999 !important;
	}

	>>>.el-dialog {
		z-index: 100000 !important;
		display: flex;
		flex-direction: column;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		max-height: calc(100% - 200px);
		max-width: calc(100% - 30px);
		margin: 0 !important;
	}

	>>>.el-dialog .el-dialog__body {
		flex: 1;
		overflow: auto;
	}

	@media (max-width: 1030px),
	(max-device-width: 1030px) {
		>>>.el-form {
			display: grid;
			grid-template-columns: 1fr !important;
			grid-row-gap: 0.5rem;
			grid-auto-flow: row;
		}
	}

	@media screen and (min-width: 1300px) and (max-width: 1900px) {
		>>>.el-dialog {
			width: 50% !important;
		}
	}

	@media screen and (min-width: 750px) and (max-width: 1300px) {
		>>>.el-dialog {
			width: 60% !important;
		}
	}

	@media screen and (min-width: 250px) and (max-width: 750px) {
		>>>.el-dialog {
			width: 70% !important;
		}
	}
</style>